export default __webpack_public_path__ + "static/media/03.5bd582d6.gif";